module.exports = __webpack_public_path__ + "static/media/Green.afa27f32.svg";